import styled from 'styled-components'

const Img = styled.img``

export default Img
